import React, { PureComponent } from 'react';
import Translator from 'translator';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainer, FHEContainerScroll, FHEContainerForm, FHETitle, FHEDivider, FHEItemText } from 'data/components';
import { Toastr } from 'data/common';
import { FlagFr, FlagEn, FlagDe, SvgTicket, SvgUser } from 'data/common/iconsvg';
import TableProjects from './Table/TableProjects';
import { getCommercialAgentDetails } from '../../data/CommercialAgents/actions';

class CommercialAgentDetails extends PureComponent {
    static propTypes = {
        getCommercialAgentDetails: PropTypes.func.isRequired,
        initialized: PropTypes.bool.isRequired,
        commercialAgent: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null
        };
    }
    componentDidMount() {
        this.getCommercialAgentDetails();
    }

    getCommercialAgentDetails = () => {
        const { getCommercialAgentDetails, match } = this.props;

        this.setState({ loading: true, error: null });

        return getCommercialAgentDetails(match.params.commercialAgentId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translate(`api.message.${err.message}`);
                Toastr.error(message);
                this.setState({
                    loading: false,
                    error: message
                });
            });
    };

    renderFlag(country) {
        switch (country) {
            case 'fr_FR':
                return <FlagFr />;
            case 'en_EN':
                return <FlagEn />;
            case 'de_DE':
                return <FlagDe />;
            default:
                return null;
        }
    }

    render() {
        const { loading, error } = this.state;
        const { commercialAgent, initialized, classes, match } = this.props;

        return (
            <FHEContainer withBackIcon loading={loading && !initialized} error={error} onClickFunc={this.getCommercialAgentDetails}>
                <FHETitle title={`${commercialAgent.get('firstname')} ${commercialAgent.get('lastname')}`} Icon={SvgUser} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.firstname')}
                                    itemContent={commercialAgent.get('firstname')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.lastname')}
                                    itemContent={commercialAgent.get('lastname')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.email')}
                                    itemContent={commercialAgent.get('email')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    loader={loading && commercialAgent.get('address') === undefined}
                                    itemTitle={Translator.translate('general.table.column.address')}
                                    itemContent={commercialAgent.get('address')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.city')}
                                    itemContent={commercialAgent.get('city')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    loader={loading && commercialAgent.get('postalCode') === undefined}
                                    itemTitle={Translator.translate('general.table.column.postalCode')}
                                    itemContent={commercialAgent.get('postalCode')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.phone')}
                                    itemContent={commercialAgent.get('phone')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.society')}
                                    itemContent={commercialAgent.get('society')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.language')}
                                    iconSimple={commercialAgent.get('language') ? this.renderFlag(commercialAgent.get('language')) : ''}
                                    itemContent={Translator.translate(`general.table.column.languages.${commercialAgent.get('language')}`)}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    loader={loading && commercialAgent.get('isActive') === undefined}
                                    itemTitle={Translator.translate('general.table.column.isActive')}
                                    classContent={commercialAgent.get('isActive') ? classes.activeColor : classes.inactiveColor}
                                    itemContent={
                                        commercialAgent.get('isActive') ? Translator.translate('general.yes') : Translator.translate('general.no')
                                    }
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>

                    <FHEDivider title={Translator.translate('general.projects')} IconComponent={SvgTicket} />
                    <TableProjects commercialAgentId={parseInt(match.params.commercialAgentId)} />
                </FHEContainerScroll>
            </FHEContainer>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const commercialAgents = state.environments[history.environment].data.CommercialAgents;

    return {
        commercialAgent: commercialAgents.getIn(['list', props.match.params.commercialAgentId], new Map()),
        initialized: commercialAgents.get('initialized')
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    activeColor: {
        color: theme.palette.success.main
    },
    inactiveColor: {
        color: theme.palette.error.main
    },
    bgColor: {
        backgroundColor: '#EBEBEB'
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getCommercialAgentDetails }, dispatch)
    )(withStyles(styles, { withTheme: true })(CommercialAgentDetails))
);



// WEBPACK FOOTER //
// ./environments/simulationenr/scenes/CommercialAgent/details.js